(function () {
  // Product Filters Functionality
  const productsFilters = () => {
    const products = document.querySelectorAll('.collection-popular-card');
    const limit = document.querySelector('.popular-products__wrapper').dataset.limit;

    document.querySelectorAll('.filters__item').forEach(item => {      
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const typeTarget = item.dataset.typeTarget;
        document.querySelectorAll('.filters__item').forEach(element => {
          element.classList.remove('filters__item_active');
        });
        item.classList.add('filters__item_active');

        let i = 0;
        products.forEach(element => {
          let productType = element.dataset.type;
          if ((productType == typeTarget || typeTarget == "all") && i < limit) {
            element.classList.add('show');
            i++;
          } else {
            element.classList.remove('show');
          }
        });
      });
    });
  };  

  // Swiper Initialization
  const initSwiper = () => {
    const swiper = new Swiper('.swiper-container-popular', {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 30,
      loop: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          let out = '';
          for (let i = 1; i <= total; i++) {
            if (i === current) {
              out += `<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="${i}" role="button" aria-label="Go to slide ${i}"></span>`;
            } else {
              out += `<span class="swiper-pagination-bullet" tabindex="${i}" role="button" aria-label="Go to slide ${i}"></span>`;
            }
          }
          return out;
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 30,
        },
      },
      touchEventsTarget: 'wrapper', // Enable swiping on mobile
    });
  };

  

  // Initialize Product Filters
  productsFilters();

  // Initialize Swiper
  initSwiper();

  // Re-initialize on Shopify section load (if applicable)
  document.addEventListener('shopify:section:load', function () {
    productsFilters();
    initSwiper(); // Re-initialize Swiper when section reloads
  });
})();